import { render, staticRenderFns } from "./PagosMenu.vue?vue&type=template&id=3f0a0dca&scoped=true&"
import script from "./PagosMenu.vue?vue&type=script&lang=js&"
export * from "./PagosMenu.vue?vue&type=script&lang=js&"
import style0 from "./PagosMenu.vue?vue&type=style&index=0&id=3f0a0dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f0a0dca",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VContainer,VFlex,VIcon,VLayout})
